import type { JSX, ReactNode } from "react";

/** Überschrift eines Abschnitts in einer App-Sidebar. */
export function SidebarSection({
  title,
  action,
  children,
}: {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}): JSX.Element {
  return (
    <section className="mb-5">
      <div className="mb-1.5 flex items-center justify-between gap-2 px-2">
        <h2 className="text-xs font-semibold uppercase tracking-wide text-ink-muted">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}

/** Ein Eintrag in einer App-Sidebar. Optional mit Zähler und Zusatz-Schaltfläche. */
export function SidebarItem({
  label,
  hint,
  icon,
  active,
  badge,
  action,
  onClick,
}: {
  label: string;
  hint?: string | null;
  icon?: ReactNode;
  active: boolean;
  badge?: number;
  action?: ReactNode;
  onClick: () => void;
}): JSX.Element {
  return (
    <div
      className={[
        "group flex items-center gap-2 rounded-lg pr-1",
        active ? "bg-brand/10" : "hover:bg-surface-sunken",
      ].join(" ")}
    >
      <button
        type="button"
        onClick={onClick}
        className="flex min-w-0 flex-1 items-center gap-2 px-2 py-2 text-left"
      >
        {icon ? <span className="shrink-0">{icon}</span> : null}
        <span className="min-w-0 flex-1">
          <span className={["block truncate text-sm", active ? "text-brand" : "text-ink"].join(" ")}>
            {label}
          </span>
          {hint ? <span className="block truncate text-xs text-ink-muted">{hint}</span> : null}
        </span>
        {badge && badge > 0 ? (
          <span className="shrink-0 rounded-full bg-brand px-1.5 text-[11px] text-brand-ink">
            {badge}
          </span>
        ) : null}
      </button>
      {action}
    </div>
  );
}
